import React from 'react';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import {lovLabel, ClosedContentProps, FormProps, FieldText, lovValue, formatValue} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {action, ObservableMap} from "mobx";
import {observer} from "mobx-react";
import {JobInfo, TEodMap} from "core/job/jobDomain";
import mdEntityService from "core/metamodel/mdEntityService";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import StyledSelect from 'core/components/fields/styledSelect';
import {DATATYPE, VALUESOURCETYPE} from "core/metamodel/mdField";
import MdField from "core/metamodel/mdField";
import styled from "styled-components";
import {formatDate, formatInterval} from "core/common/utils/dateUtils";
import {EVENTTYPE} from "core/event/eventDomain";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import {grey400} from "material-ui/styles/colors";
import NumberField from "core/components/fields/numberField";
import {Min, NumberFormat, PrimaryKeyString} from "core/form/rules";
import tenantService from "../tenant/service/tenantService";

const transformedTextThStyle = {
  height: "200px",
  lineHeight: "14px",
  paddingBottom: "20px",
  textAlign: "left"
};

const transformedTextDivStyle: any = {
  marginLeft: "-75px",
  position: "absolute",
  width: "195px",
  transform: "rotate(-90deg)",
  lineHeight: "14px",
  textAlign: "left"
};

const checkboxTdStyle = {
  textAlign: "center"
};

const HeadingDiv = styled.div`
  font-size: 18px;
  color: ${grey400}
`;

/* ************************************************************************************************
 * ***********   EODForm *************************************************************
 * ********************************************************************************************** */

type TEodDef = { [step: string]: number[] };

interface EodTableProps {
  eodMap: TEodMap;
  dataObject: JobInfo;
  disabled?: boolean;
  onChange?: (tenantId: number, step: string, checked: boolean) => void;
}

@observer
class EodTable extends React.Component<EodTableProps, null> {

  onChangeEodMap = (tenantId, step, evt) => {
    let {eodMap, onChange} = this.props;
    let checked = evt.target.checked;
    eodMap[tenantId][step] = checked;
    console.log("onChangeEodMap ", tenantId, step, checked, eodMap);
    if (onChange) {
      onChange(tenantId, step, checked);
    }
  };


  render() {
    const {eodMap, disabled, dataObject} = this.props;

    if (!eodMap) return <noscript/>;

    let eodPhaseEntity = mdEntityService.getEntity("EODPHASE");
    let tenantEntity = mdEntityService.getEntity("Tenant");

    let phasesBodLV = eodPhaseEntity.lovItems.filter(lv => lv["BoD"]);
    let phasesEodLV = eodPhaseEntity.lovItems.filter(lv => !lv["BoD"]);


    return (

      <div style={{display: 'flex'}}>

        <div>
          <HeadingDiv>
            <span>End of date</span> <span> ({formatDate(dataObject.oldBusinessDate)})</span>
          </HeadingDiv>
          <table>
            <thead>
            <tr>
              <th/>
              {phasesEodLV.map(li => <th key={li.value} style={transformedTextThStyle}>
                <div
                  style={transformedTextDivStyle}>{lovLabel(li)}</div>
              </th>)}
            </tr>
            </thead>
            <tbody>
            {tenantEntity.lovItems.map(tenant => (
              <tr key={tenant.value}>
                <td>{lovLabel(tenant)}</td>
                {phasesEodLV.map(step => (
                  <td key={step.value} style={checkboxTdStyle}>
                    <MdCheckbox checked={eodMap[tenant.value][step.value]} disabled={disabled}
                                onCheck={this.onChangeEodMap.bind(this, tenant.value, step.value)}/>
                  </td>
                ))}
              </tr>
            ))}
            </tbody>
          </table>
        </div>

        <div style={{width: 40}} className="block-comp-right-border"/>
        <div style={{width: 40}}/>


        <div>
          <HeadingDiv>
            <span>Begining of date</span> <span>  ({formatDate(dataObject.newBusinessDate)})</span>
          </HeadingDiv>
          <table>
            <thead>
            <tr>
              <th/>
              {phasesBodLV.map(li => <th key={li.value} style={transformedTextThStyle}>
                <div
                  style={transformedTextDivStyle}>{lovLabel(li)}</div>
              </th>)}
            </tr>
            </thead>
            <tbody>
            {tenantEntity.lovItems.map(tenant => (
              <tr key={tenant.value}>
                <td>{lovLabel(tenant)}</td>
                {phasesBodLV.map(step => (
                  <td key={step.value} style={checkboxTdStyle}>
                    <MdCheckbox checked={eodMap[tenant.value][step.value]} disabled={disabled}
                                onCheck={this.onChangeEodMap.bind(this, tenant.value, step.value)}/>
                  </td>
                ))}
              </tr>
            ))}
            </tbody>
          </table>
        </div>

      </div>


    );
  }

}

const EODClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<JobInfo>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>
    <EodTable eodMap={dataObject.eodMap} disabled dataObject={dataObject}/>
  </div>
);

@createForm({
  formName: 'EODForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }],
  onCommit(dataObject) {
    // konvertuju z TEodMap do TEodDef
    dataObject.arguments = [Object.entries(dataObject.eodMap).reduce((acc, [tenantId, stepMap]) => {
      Object.entries(stepMap).filter(([step, checked]) => checked).forEach(([step, checked]) => {
        let tenants = acc[step];
        if (!tenants) {
          tenants = [];
          acc[step] = tenants;
        }
        tenants.push(parseInt(tenantId));
      });
      return acc;
    }, {})];
  }
}, EODClosedContent)
@observer
export class EODForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {


  componentWillReceiveProps(nextProps) {
    console.debug('EODForm componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('EODForm componentDidMount');
    let {dataObject} = this.props;

    mdEntityService.fetchEntities([{entity: 'EODPHASE', lov: true}, {
      entity: 'Tenant',
      lov: true
    }]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      let eodPhaseEntity = entityMap.get("EODPHASE");
      let tenantEntity = entityMap.get("Tenant");

      let eodDef: TEodDef = (dataObject.arguments && dataObject.arguments.length) ? dataObject.arguments[0] : null;

      // Vytvorim prazdnou mapu TEodMap a zaskrtam policka podle TEodDef
      dataObject.eodMap = tenantEntity.lovItems.reduce((acc, tenant) => {
        acc[tenant.value] = eodPhaseEntity.lovItems.reduce((phases, eodPhase) => {
          phases[eodPhase.value] = !!(eodDef && eodDef[eodPhase.value] && eodDef[eodPhase.value].includes(tenant.value as number));
          return phases;
        }, {});
        return acc;
      }, {});


    }));

  }

  onChange = (tenantId: number, step: string, checked: boolean) => {
    this.props.rootObject.$dirty = true;
  };

  render() {

    console.log("render EODForm ", this.props.dataObject.eodMap);

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, eodMap} = fields;

    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...name.props} disabled={!dataObject.$new}/>
            <Validate field={name} value={name.props.value}/>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <EodTable eodMap={dataObject.eodMap} onChange={this.onChange} dataObject={dataObject}/>
          </div>
        </div>
      </div>
    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<EODClosedContent {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }
}


/* ************************************************************************************************
 * ***********   InvoiceToAccForm *************************************************************
 * ********************************************************************************************** */


const InvoiceToAccFormCC = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<JobInfo>) => (

  <div>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}} singleColumn>
      <ClosedFormField label={fields.documentTypes.textLabel} value={dataObject.documentTypes}/>
      <ClosedFormField label={fields.eventType.textLabel} value={dataObject.eventType}/>
      <ClosedFormField label={fields.invoiceTypes.textLabel} value={dataObject.invoiceTypes}/>
      <ClosedFormField label={fields.limitByProfitCenter.textLabel} value={dataObject.limitByProfitCenter}
                       mdField={fields.limitByProfitCenter.mdField}/>
      <ClosedFormField label={fields.profitCenters.textLabel} value={dataObject.profitCenters}/>
      <ClosedFormField label={fields.onlyForDomesticCustomers.textLabel} value={dataObject.onlyForDomesticCustomers}
                       mdField={fields.onlyForDomesticCustomers.mdField}/>
      <ClosedFormField label={fields.waitForTaxConfirmation.textLabel} value={dataObject.waitForTaxConfirmation}
                       mdField={fields.waitForTaxConfirmation.mdField}/>
    </ClosedFormBlock>

  </div>
);

@createForm({
  formName: 'InvoiceToAccForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'documentTypes',
    validators: ['IsRequired'],
    omitNullOption: true,
    mdField: new MdField({label: 'Document Types', valueSource: 'DocumentType', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'eventType',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Event Type', valueSource: 'EventType', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'invoiceTypes',
    validators: ['IsRequired'],
    omitNullOption: true,
    mdField: new MdField({label: 'Invoice Types', valueSource: 'InvoiceType', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'limitByProfitCenter',
    mdField: new MdField({label: 'Limit by Profit Centers', dataType: DATATYPE.BOOLEAN})
  }, {
    name: 'onlyForDomesticCustomers',
    mdField: new MdField({label: 'Only for Domestic Customers', dataType: DATATYPE.BOOLEAN})
  }, {
    name: 'waitForTaxConfirmation',
    mdField: new MdField({label: 'Wait for Tax Confirmation', dataType: DATATYPE.BOOLEAN})
  }, {
    name: 'profitCenters',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Profit centers', valueSource: 'ProfitCenter', valueSourceType: VALUESOURCETYPE.LOCAL})
  }],
  onCommit(dataObject) {
    dataObject.arguments = [(dataObject.documentTypes) ? dataObject.documentTypes.map(dtLov => lovValue(dtLov)) : [], // 1
      lovValue(dataObject.eventType),  // 2
      dataObject.limitByProfitCenter!!,  // 3
      (dataObject.profitCenters) ? dataObject.profitCenters.map(dtLov => lovValue(dtLov)) : [],  // 4
      (dataObject.invoiceTypes) ? dataObject.invoiceTypes.map(lov => lovValue(lov)) : [], // 5
      dataObject.onlyForDomesticCustomers!!,  // 6
      dataObject.waitForTaxConfirmation!!  // 7
    ];
  }
}, InvoiceToAccFormCC)
@observer
export class InvoiceToAccForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {

  componentWillReceiveProps(nextProps) {
    console.debug('InvoiceToAccForm componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('InvoiceToAccForm componentDidMount');
    let {dataObject, form} = this.props;

    let docTypesIds = (dataObject.arguments && dataObject.arguments.length) ? dataObject.arguments[0].slice() : [];
    let eventTypeIds = (dataObject.arguments && dataObject.arguments.length > 1) ? [dataObject.arguments[1]] : [];

    Promise.all([mdEntityService.fetchEntities([{entity: 'DocumentType', lov: true}, {
      entity: 'EventType',
      lov: true
    }, {entity: 'ProfitCenter'}, {entity: "InvoiceType", lov: true}]),
      tenantService.getBindedTenants(["DocumentType", "EventType"], {
        "DocumentTypeIds": docTypesIds,
        "EventTypeIds": eventTypeIds
      })])
      .then(([entityMap, tenantLovs]: [ObservableMap<MdEntity>, LovItem<number>[]]) => {
        form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
        if (dataObject.arguments && dataObject.arguments.length) {
          let dtMdEntity = entityMap.get("DocumentType");
          dataObject.documentTypes = (docTypesIds && docTypesIds.length) ? docTypesIds.map(dtId => dtMdEntity.getLovItem(dtId)) : [];
        }

        let eventTypeEntity = entityMap.get("EventType");
        if (dataObject.arguments && dataObject.arguments.length > 1) {
          dataObject.eventType = eventTypeEntity.getLovItem(dataObject.arguments[1]);
        }

        if (dataObject.arguments && dataObject.arguments.length > 2) {
          dataObject.limitByProfitCenter = dataObject.arguments[2]!!;
        }

        let invoiceTypeEntity = entityMap.get("InvoiceType");
        if (dataObject.arguments && dataObject.arguments.length > 4) {
          let invoiceTypeIds = dataObject.arguments[4];
          dataObject.invoiceTypes = (invoiceTypeIds && invoiceTypeIds.length) ? invoiceTypeIds.map(dtId => invoiceTypeEntity.lovItems.find(x => x.value === dtId)).filter(x => !!x) : [];
        }

        if (dataObject.arguments && dataObject.arguments.length > 5) {
          dataObject.onlyForDomesticCustomers = dataObject.arguments[5]!!;
        }

        if (dataObject.arguments && dataObject.arguments.length > 6) {
          dataObject.waitForTaxConfirmation = dataObject.arguments[6]!!;
        }

        form.getField("eventType").props.options = eventTypeEntity.lovItems.filter(li => li["eventType"] === ((dataObject.group === 'InvoiceToAcc') ? EVENTTYPE.INVOICE_SENT_ACCOUNTING : EVENTTYPE.INVOICE_SENT_TAX_OFFICE));

        return (tenantLovs.length) ? mdEntityService.fetchMissingEntityLovs(["ProfitCenter"], tenantLovs.map(lov => lovValue(lov))) : Promise.resolve({"ProfitCenter": []});
      })
      .then((lovsMap: { [key: string]: LovItem[] }) => {
        let profitCenterLovs = lovsMap["ProfitCenter"];
        form.getField("profitCenters").props.options = profitCenterLovs;

        if (dataObject.arguments && dataObject.arguments.length > 3) {
          let profitCenterIds = dataObject.arguments[3];
          dataObject.profitCenters = (profitCenterIds && profitCenterIds.length) ? profitCenterIds.map(dtId => profitCenterLovs.find(x => x.value === dtId)).filter(x => !!x) : [];
        }

        form.updateAllFieldsPropValue(dataObject);
      });

  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, documentTypes, eventType, profitCenters, limitByProfitCenter, invoiceTypes, onlyForDomesticCustomers, waitForTaxConfirmation} = fields;


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...name.props} disabled={!dataObject.$new}/>
            <Validate field={name} value={name.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...documentTypes.props} multi onChange={this.onChangeDocumentTypes} />
            <Validate field={documentTypes} value={documentTypes.props.value} dataObject={dataObject} />
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...eventType.props} />
            <Validate field={eventType} value={eventType.props.value} dataObject={dataObject} onSuccess={this.onSuccessEventType}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...invoiceTypes.props} multi/>
            <Validate field={invoiceTypes} value={invoiceTypes.props.value} dataObject={dataObject}/>
          </div>

          <div className="fx col-xs-12 col-sm-4">
            <MdCheckbox {...limitByProfitCenter.props} onCheck={this.handleLimitByProfitCenter}/>
          </div>

          {(dataObject.limitByProfitCenter) ? (
            <div className="fx col-xs-6 col-sm-4">
              <StyledSelect {...profitCenters.props} multi/>
              <Validate field={profitCenters} value={profitCenters.props.value} dataObject={dataObject}/>
            </div>
          ) : null}
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdCheckbox {...onlyForDomesticCustomers.props} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <MdCheckbox {...waitForTaxConfirmation.props} />
          </div>
        </div>

      </div>

    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<InvoiceToAccFormCC {...{ dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }

  @action handleLimitByProfitCenter = (evt) => {
    let {entities, dataObject, form, rootObject} = this.props;
    console.debug('handleLimitByProfitCenter ', evt, dataObject.limitByProfitCenter);
    form.getField("limitByProfitCenter").props.onCheck(evt);
    dataObject.profitCenters = [];
    form.updateFieldsPropValue(dataObject, "profitCenters");
  };

  @action onSuccessEventType = () => {
    let {dataObject, form} = this.props;
    tenantService.getBindedTenants(["DocumentType", "EventType"], {
      "DocumentTypeIds": dataObject.documentTypes.map(x => lovValue(x)),
      "EventTypeIds": [lovValue(dataObject.eventType)]
    })
      .then((tenantLovs: LovItem[]) => {
        return (tenantLovs.length) ? mdEntityService.fetchMissingEntityLovs(["ProfitCenter"], tenantLovs.map(lov => lovValue(lov))) : Promise.resolve({"ProfitCenter": []});
      })
      .then((lovsMap: { [key: string]: LovItem[] }) => {
        let profitCenterLovs = lovsMap["ProfitCenter"];
        form.getField("profitCenters").props.options = profitCenterLovs;
        dataObject.profitCenters = (dataObject.profitCenters && dataObject.profitCenters.length) ? dataObject.profitCenters.map(lov => profitCenterLovs.find(x => lovValue(x) === lovValue(lov))).filter(x => !!x) : [];
        form.updateFieldsPropValue(dataObject, "profitCenters");
      });
  }

  @action onChangeDocumentTypes = (evt) => {
    let {dataObject, form} = this.props;
    let field = form.getField("documentTypes");
    field.props.onChange(evt);
    form.updateFieldPropValue(field, dataObject);
    this.onSuccessEventType();
  }


}


/* ************************************************************************************************
 * ***********   DownloadBankTx *************************************************************
 * ********************************************************************************************** */


const DownloadBankTxCC = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<JobInfo>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>
    <div className="form-text-row">
      <FieldText label={fields.tenants.textLabel}
                 value={(dataObject.tenants && dataObject.tenants.length) ? dataObject.tenants.map((dt, index) => lovLabel(dt)).join(", ") : null}/>
    </div>
    <div className="form-text-row">
      <FieldText label={fields.bankApiTypes.textLabel}
                 value={(dataObject.bankApiTypes && dataObject.bankApiTypes.length) ? dataObject.bankApiTypes.map((dt, index) => lovLabel(dt)).join(", ") : null}/>
    </div>
  </div>
);

@createForm({
  formName: 'DownloadBankTxForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'tenants',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Tenants', valueSource: 'Tenant', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'bankApiTypes',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Bank API types', valueSource: 'BANKAPITYPE', valueSourceType: VALUESOURCETYPE.LOCAL})
  }],
  onCommit(dataObject) {
    dataObject.arguments = [dataObject.tenants.map(dtLov => lovValue(dtLov)), dataObject.bankApiTypes.map(dtLov => lovValue(dtLov))];
  }
}, DownloadBankTxCC)
@observer
export class DownloadBankTxForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {


  componentWillReceiveProps(nextProps) {
    console.debug('DownloadBankTxForm componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('DownloadBankTxForm componentDidMount');
    let {dataObject, form} = this.props;

    mdEntityService.fetchEntities([{entity: 'Tenant', lov: true}, {
      entity: 'BANKAPITYPE',
      lov: true
    }]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
      if (dataObject.arguments && dataObject.arguments.length) {
        let tenantIds = dataObject.arguments[0];
        let tnMdEntity = entityMap.get("Tenant");
        dataObject.tenants = (tenantIds && tenantIds.length) ? tenantIds.map(dtId => tnMdEntity.getLovItem(dtId)) : [];
      }


      if (dataObject.arguments && dataObject.arguments.length > 1) {
        let bankApiIds = dataObject.arguments[1];
        let apiTypeEntity = entityMap.get("BANKAPITYPE");
        dataObject.bankApiTypes = (bankApiIds && bankApiIds.length) ? bankApiIds.map(dtId => apiTypeEntity.getLovItem(dtId)) : [];
      }
      form.updateAllFieldsPropValue(dataObject);
    }));

  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, tenants, bankApiTypes} = fields;


    const openContent = (
      <div className="row">
        <div className="fx col-xs-12 col-sm-4">
          <MdTextField {...name.props} disabled={!dataObject.$new}/>
          <Validate field={name} value={name.props.value}/>
        </div>
        <div className="fx col-xs-6 col-sm-4">
          <StyledSelect {...tenants.props} multi/>
          <Validate field={tenants} value={tenants.props.value} dataObject={dataObject}/>
        </div>
        <div className="fx col-xs-6 col-sm-4">
          <StyledSelect {...bankApiTypes.props} multi/>
          <Validate field={bankApiTypes} value={bankApiTypes.props.value} dataObject={dataObject}/>
        </div>
      </div>

    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<DownloadBankTxCC {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }
}

/* ************************************************************************************************
 * ***********   ProcessBrimMessage   *************************************************************
 * ********************************************************************************************** */


const ProcessBrimMessage = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<JobInfo>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>
    <div className="form-text-row">
      <FieldText label={fields.tenants.textLabel}
                 value={(dataObject.tenants && dataObject.tenants.length) ? dataObject.tenants.map((dt, index) => lovLabel(dt)).join(", ") : null}/>
    </div>
    <div className="form-text-row">
      <FieldText label={fields.invalidate.textLabel}
                 value={dataObject.invalidate}/>
    </div>
  </div>
);

@createForm({
  formName: 'ProcessBrimMessageForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'tenants',
    mdField: new MdField({label: 'Tenants', valueSource: 'Tenant', valueSourceType: VALUESOURCETYPE.LOCAL})
  },{
    name: 'invalidate',
    mdField: new MdField({label: 'Invalidate  message after (days)', dataType: DATATYPE.NUMBER})
  }],
  onCommit(dataObject) {
    dataObject.arguments = [(dataObject.tenants)?dataObject.tenants.map(dtLov => lovValue(dtLov)):[], dataObject.invalidate];
  }
}, ProcessBrimMessage)
@observer
export class ProcessBrimMessageForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {


  componentWillReceiveProps(nextProps) {
    console.debug('ProcessBrimMessage componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('ProcessBrimMessage componentDidMount');
    let {dataObject, form} = this.props;

    mdEntityService.fetchEntities([{entity: 'Tenant', lov: true}]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
      
      if (dataObject.arguments && dataObject.arguments.length) {
        let tenantIds = dataObject.arguments[0];
        let tnMdEntity = entityMap.get("Tenant");
        dataObject.tenants = (tenantIds && tenantIds.length) ? tenantIds.map(dtId => tnMdEntity.getLovItem(dtId)) : [];
      }

      // limit
      if (dataObject.arguments && dataObject.arguments.length > 1) {
        dataObject.invalidate = dataObject.arguments[1];
      }

      form.updateAllFieldsPropValue(dataObject);
    }));

  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, tenants, invalidate} = fields;


    const openContent = (
      <div className="row">
        <div className="fx col-xs-12 col-sm-4">
          <MdTextField {...name.props} disabled={!dataObject.$new}/>
          <Validate field={name} value={name.props.value}/>
        </div>
        <div className="fx col-xs-6 col-sm-4">
          <StyledSelect {...tenants.props} multi/>
          <Validate field={tenants} value={tenants.props.value} dataObject={dataObject}/>
        </div>
        <div className="fx col-xs-6 col-sm-4">
            <NumberField {...invalidate.props}/>
            <Validate field={invalidate} value={invalidate.props.value}>
              <NumberFormat precision={10} scale={0} value={undefined}/>
              <Min min={0} value={undefined}/>
            </Validate>
          </div>
      </div>

    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<ProcessBrimMessage {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }
}


/* ************************************************************************************************
 * ***********   InvoiceToArchiveForm *************************************************************
 * ********************************************************************************************** */


const InvoiceToArchiveFormCC = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<JobInfo>) => (
  <div>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}} singleColumn>
      <ClosedFormField label={fields.documentTypes.textLabel} value={dataObject.documentTypes}/>
      <ClosedFormField label={fields.eventType.textLabel} value={dataObject.eventType}/>
      <ClosedFormField label={fields.invoiceTypes.textLabel} value={dataObject.invoiceTypes}/>
      <ClosedFormField label={fields.mainDocument.textLabel} value={dataObject.mainDocument}/>
      <ClosedFormField label={fields.mainDocumentNameExpression.textLabel}
                       value={dataObject.mainDocumentNameExpression}/>
      <ClosedFormField label={fields.attachedDocuments.textLabel} value={dataObject.attachedDocuments}
                       mdField={fields.attachedDocuments.mdField}/>
      <ClosedFormField label={fields.archivingFormat.textLabel} value={dataObject.archivingFormat}/>
      <ClosedFormField label={fields.archiveFilenameExpression.textLabel} value={dataObject.archiveFilenameExpression}/>
    </ClosedFormBlock>

  </div>

);


@createForm({
  formName: 'InvoiceToArchiveForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'documentTypes',
    validators: ['IsRequired'],
    mdField: new MdField({
      label: 'Document Types for accompanying documents',
      valueSource: 'DocumentType',
      valueSourceType: VALUESOURCETYPE.LOCAL
    })
  }, {
    name: 'eventType',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Event Type', valueSource: 'EventType', valueSourceType: VALUESOURCETYPE.LOCAL})
  },{
    name: 'invoiceTypes',
    validators: ['IsRequired'],
    omitNullOption: true,
    mdField: new MdField({label: 'Invoice Types', valueSource: 'InvoiceType', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'mainDocument',
    mdField: new MdField({
      label: 'Main document location',
      valueSource: 'DOCUMENTLOCATION',
      valueSourceType: VALUESOURCETYPE.LOCAL
    })
  }, {
    name: 'mainDocumentNameExpression',
    mdField: new MdField({label: 'Main document name expression', dataType: DATATYPE.STRING})
  }, {
    name: 'attachedDocuments',
    mdField: new MdField({label: 'Add Attached documents', dataType: DATATYPE.BOOLEAN})
  }, {
    name: 'archivingFormat',
    mdField: new MdField({
      label: 'ArchivingFormat',
      valueSource: 'DOCUMENTFORMAT',
      valueSourceType: VALUESOURCETYPE.LOCAL
    })
  }, {
    name: 'archiveFilenameExpression',
    mdField: new MdField({label: 'Archive file name expression', dataType: DATATYPE.STRING})
  }],
  onCommit(dataObject) {
    dataObject.arguments = [(dataObject.documentTypes) ? dataObject.documentTypes.map(dtLov => lovValue(dtLov)) : [], // 1
      lovValue(dataObject.eventType), // 2
      lovValue(dataObject.mainDocument), // 3
      dataObject.mainDocumentNameExpression, // 4
      dataObject.attachedDocuments, // 5
      lovValue(dataObject.archivingFormat), // 6
      dataObject.archiveFilenameExpression, // 7
      (dataObject.invoiceTypes) ? dataObject.invoiceTypes.map(lov => lovValue(lov)) : [] // 8
    ];
  }
}, InvoiceToArchiveFormCC)
@observer
export class InvoiceToArchiveForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {


  componentWillReceiveProps(nextProps) {
    console.debug('InvoiceToArchiveForm componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('InvoiceToArchiveForm componentDidMount');
    let {dataObject, form} = this.props;

    mdEntityService.fetchEntities([{entity: 'DocumentType', lov: true}, {entity: 'EventType', lov: true},
      {entity: "DOCUMENTLOCATION", lov: true}, {
        entity: "DOCUMENTFORMAT",
        lov: true
      }, {entity: "InvoiceType", lov: true}]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);

      // documentTypes
      if (dataObject.arguments && dataObject.arguments.length) {
        let docTypesIds = dataObject.arguments[0];
        let dtMdEntity = entityMap.get("DocumentType");
        dataObject.documentTypes = (docTypesIds && docTypesIds.length) ? docTypesIds.map(dtId => dtMdEntity.getLovItem(dtId)) : [];
      }

      // eventType
      let eventTypeEntity = entityMap.get("EventType");
      if (dataObject.arguments && dataObject.arguments.length > 1) {
        dataObject.eventType = eventTypeEntity.getLovItem(dataObject.arguments[1]);
      }

      // mainDocument
      if (dataObject.arguments && dataObject.arguments.length > 2) {
        let documentLocationEntity = entityMap.get("DOCUMENTLOCATION");
        dataObject.mainDocument = documentLocationEntity.getLovItem(dataObject.arguments[2]);
      }

      // mainDocumentNameExpression
      if (dataObject.arguments && dataObject.arguments.length > 3) {
        dataObject.mainDocumentNameExpression = dataObject.arguments[3];
      }

      // attachedDocuments
      if (dataObject.arguments && dataObject.arguments.length > 4) {
        dataObject.attachedDocuments = dataObject.arguments[4];
      }

      // archivingFormat
      let documentFormatEntity = entityMap.get("DOCUMENTFORMAT");
      if (dataObject.arguments && dataObject.arguments.length > 5) {
        dataObject.archivingFormat = documentFormatEntity.getLovItem(dataObject.arguments[5]);
      }

      // archiveFilenameExpression
      if (dataObject.arguments && dataObject.arguments.length > 6) {
        dataObject.archiveFilenameExpression = dataObject.arguments[6];
      }

      let invoiceTypeEntity = entityMap.get("InvoiceType");
      if (dataObject.arguments && dataObject.arguments.length > 7) {
        let invoiceTypeIds = dataObject.arguments[7];
        dataObject.invoiceTypes = (invoiceTypeIds && invoiceTypeIds.length) ? invoiceTypeIds.map(dtId => invoiceTypeEntity.lovItems.find(x => x.value === dtId)).filter(x => !!x) : [];
      }


      form.updateAllFieldsPropValue(dataObject);
      form.getField("eventType").props.options = eventTypeEntity.lovItems.filter(li => li["eventType"] === EVENTTYPE.INVOICE_SENT_ARCHIVE);
      form.getField("archivingFormat").props.options = documentFormatEntity.lovItems.filter(li => li["archive"]);
    }));

  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {
      name,
      documentTypes,
      eventType,
      mainDocument,
      mainDocumentNameExpression,
      attachedDocuments,
      archivingFormat,
      archiveFilenameExpression,
      invoiceTypes
    } = fields;


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...name.props} disabled={!dataObject.$new}/>
            <Validate field={name} value={name.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...documentTypes.props} multi/>
            <Validate field={documentTypes} value={documentTypes.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...eventType.props} />
            <Validate field={eventType} value={eventType.props.value} dataObject={dataObject}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...mainDocument.props} />
            <Validate field={mainDocument} value={mainDocument.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-12 col-sm-8">
            <MdTextField {...mainDocumentNameExpression.props} />
            <Validate field={mainDocumentNameExpression} value={mainDocumentNameExpression.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-4">
            <StyledSelect {...archivingFormat.props} />
            <Validate field={archivingFormat} value={archivingFormat.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-12 col-sm-8">
            <MdTextField {...archiveFilenameExpression.props} />
            <Validate field={archiveFilenameExpression} value={archiveFilenameExpression.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...invoiceTypes.props} multi/>
            <Validate field={invoiceTypes} value={invoiceTypes.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <MdCheckbox {...attachedDocuments.props}/>
          </div>
        </div>


      </div>

    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<InvoiceToArchiveFormCC {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }
}


/* ************************************************************************************************
 * ***********   QueueForm *************************************************************
 * ********************************************************************************************** */


const QueueFormCC = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<JobInfo>) => (
  <div>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}} singleColumn>
      <ClosedFormField label={fields.queueTypes.textLabel}
                       value={(dataObject.queueTypes && dataObject.queueTypes.length) ? dataObject.queueTypes.map((dt) => lovLabel(dt)).join(", ") : null}/>
      <ClosedFormField label={fields.limit.textLabel} value={dataObject.limit}/>
    </ClosedFormBlock>

  </div>

);


@createForm({
  formName: 'QueueForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'queueTypes',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Queue Types', valueSource: 'QUEUETYPE', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'limit',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Max number of queue items processed in one job', dataType: DATATYPE.NUMBER})
  }],
  onCommit(dataObject) {
    dataObject.arguments = [(dataObject.queueTypes) ? dataObject.queueTypes.map(dtLov => lovValue(dtLov)) : [], dataObject.limit];
  }
}, QueueFormCC)
@observer
export class QueueForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {


  componentWillReceiveProps(nextProps) {
    console.debug('QueueForm componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('QueueForm componentDidMount');
    let {dataObject, form} = this.props;

    mdEntityService.fetchEntities([{
      entity: 'QUEUETYPE',
      lov: true
    }]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);

      // QUEUETYPE
      if (dataObject.arguments && dataObject.arguments.length) {
        let QUEUETYPES = dataObject.arguments[0];
        let QUEUETYPEMdEntity = entityMap.get("QUEUETYPE");
        dataObject.queueTypes = (QUEUETYPES && QUEUETYPES.length) ? QUEUETYPES.map(qt => QUEUETYPEMdEntity.getLovItem(qt)) : [];
      }

      // limit
      if (dataObject.arguments && dataObject.arguments.length > 1) {
        dataObject.limit = dataObject.arguments[1];
      }

      form.updateAllFieldsPropValue(dataObject);
    }));

  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, queueTypes, limit} = fields;


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...name.props} disabled={!dataObject.$new}/>
            <Validate field={name} value={name.props.value}>
              <PrimaryKeyString value={undefined}/>
            </Validate>
          </div>
          <div className="fx col-xs-12 col-sm-8">
            <StyledSelect {...queueTypes.props} multi/>
            <Validate field={queueTypes} value={queueTypes.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <NumberField {...limit.props}/>
            <Validate field={limit} value={limit.props.value}>
              <NumberFormat precision={10} scale={0} value={undefined}/>
              <Min min={0} value={undefined}/>
            </Validate>
          </div>
        </div>

      </div>

    );

    return (
      <ActiveItem openContent={openContent} closedContent={<QueueFormCC {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }
}


/* ************************************************************************************************
 * ***********   DataImport *************************************************************
 * ********************************************************************************************** */


const DataImportFormCC = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<JobInfo>) => (
  <div>
    <h3>{dataObject.group + ' - ' + dataObject.name}</h3>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}} singleColumn>
      <ClosedFormField label={fields.importType.textLabel} value={dataObject.importType}/>
      <ClosedFormField label={fields.directory.textLabel} value={dataObject.directory}/>
      <ClosedFormField label={fields.filenamePattern.textLabel} value={dataObject.filenamePattern}/>
    </ClosedFormBlock>

  </div>

);


@createForm({
  formName: 'DataImportForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'importType',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Import Type', valueSource: 'IMPORTTYPE', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'directory',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Import files directory', dataType: DATATYPE.STRING})
  }, {
    name: 'filenamePattern',
    validators: ['IsRequired'],
    mdField: new MdField({label: 'Filename pattern', dataType: DATATYPE.STRING})
  }],
  onCommit(dataObject) {
    dataObject.arguments = [lovValue(dataObject.importType), dataObject.directory, dataObject.filenamePattern];
  }
}, DataImportFormCC)
@observer
export class DataImportForm extends React.Component<FormProps<JobInfo, JobInfo>, undefined> {


  componentWillReceiveProps(nextProps) {
    console.debug('DataImportForm componentWillReceiveProps ', nextProps);
  }

  componentDidMount() {
    console.debug('DataImportForm componentDidMount');
    let {dataObject, form} = this.props;

    mdEntityService.fetchEntities([{
      entity: 'IMPORTTYPE',
      lov: true
    }]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);

      // IMPORTTYPE
      if (dataObject.arguments && dataObject.arguments.length) {
        let IMPORTTYPE = dataObject.arguments[0];
        let IMPORTTYPEMdEntity = entityMap.get("IMPORTTYPE");
        dataObject.importType = IMPORTTYPEMdEntity.getLovItem(IMPORTTYPE);
      }

      // directory
      if (dataObject.arguments && dataObject.arguments.length > 1) {
        dataObject.directory = dataObject.arguments[1];
      }

      // filenamePattern
      if (dataObject.arguments && dataObject.arguments.length > 2) {
        dataObject.filenamePattern = dataObject.arguments[2];
      }


      form.updateAllFieldsPropValue(dataObject);
    }));

  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, importType, directory, filenamePattern} = fields;


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...name.props} disabled={!dataObject.$new}/>
            <Validate field={name} value={name.props.value}/>
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...importType.props} />
            <Validate field={importType} value={importType.props.value} dataObject={dataObject}/>
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...directory.props}/>
            <Validate field={directory} value={directory.props.value}/>
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...filenamePattern.props}/>
            <Validate field={filenamePattern} value={filenamePattern.props.value}/>
          </div>
        </div>

      </div>

    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<DataImportFormCC {...{dataObject, entity, entities, fields}} />}
                  validate={this.props.validate} disableEditing={disabled} {...this.props} />
    );
  }
}




// WEBPACK FOOTER //
// ./src/core/job/jobDetailForms.tsx